import classes from "./Report.module.css"
import React, {useEffect, useRef, useState} from "react";
import { ReactComponent as ARROW_RIGHT } from "../../images/arrow_right.svg";
import {MonthPicker} from "./MonthPicker";
import {ReactComponent as POLL_ICON}  from "./images/MetricIconPoll.svg";
import {ReactComponent as ATTENDANCE_ICON}  from "./images/MetricIconAttendance.svg";
import {ReactComponent as RESPONSE_ICON}  from "./images/MetricIconResponse.svg";
import {ReactComponent as PARTICIPANT_ICON}  from "./images/MetricIconParticipant.svg";
import {ReactComponent as LINE_CHART_ICON}  from "./images/LineChartInstIcon.svg";
import {ReactComponent as TABLE_ICON}  from "./images/LineChartCourseIcon.svg";

import { MENU_LIST, REPORT_INSTITUTION_PAGE_TAB_KEY } from "../../utils/constants";
import {YuJaCheckbox} from "../../components/standardization/YuJaCheckbox";
import {CartesianGrid, LineChart, Tooltip, XAxis, YAxis, Line, Label, ResponsiveContainer} from "recharts";
import TabCourses from "./TabCourses";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import TabStandalone from "./TabStandalone";
import {
    getFullMonthYear,
    getMetricBGColorByCount,
    getMetricColorByCount,
    getShortMonthYear,
    getTrendByCount, getYearMonthStr, isCountIncreased
} from "./ReportHelper";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {LineChartTooltip} from "./LineChartTooltip";
import {LineChartTick} from "./LineChartTick";
import {useReportMetricCardDivider} from "../../hooks/useReportMetricCardDivider";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { Tabs } from '@base-ui/react/tabs';
import { useTranslation } from "react-i18next";

export default function ReportInstPage(props) {
    const { t } = useTranslation();
    const { isUserWise=false } = props;
    const {getInstitutionWiseReport, getUserWiseReport} = ReportApiCalls();
    let {width: windowWidth} = useWindowDimensions();

    const [reportStartDate, setReportStartDate] = useState(() => {
        let currentDate = new Date();
        currentDate.setDate(1);
        currentDate.setMonth(currentDate.getMonth() - 6);
        return getYearMonthStr(currentDate);
    });

    const [reportEndDate, setReportEndDate] = useState(() =>{
        let currentDate = new Date();
        currentDate.setDate(1);
        return getYearMonthStr(currentDate);
    });

    const [curDate, ] = useState(() =>{
        let currentDate = new Date();
        currentDate.setDate(1);
        return getYearMonthStr(currentDate);
    });
    const [showOverallLine, setShowOverallLine] = useState(true);
    const [showPollLine, setShowPollLine] = useState(true);
    const [showAttendanceLine, setShowAttendanceLine] = useState(true);
    const [activeTab, setActiveTab] = useState(REPORT_INSTITUTION_PAGE_TAB_KEY.COURSES);
    const [coursesData, setCoursesData] = useState([]);
    const [nanCourseData, setNanCourseData] = useState({});
    const [lastMonthCount, setLastMonthCount] = useState({});
    const [overviewCount, setOverviewCount] = useState({});
    const [lineChartData, setLineChartData] = useState([]);
    const [chartDiagramWidth, setChartDiagramWidth] = useState(45);
    const [dataLoading, setDataLoading] = useState(false);
    const [lastMonthDisplay, setLastMonthDisplay] = useState("");
    const [activeLabel, setActiveLabel] = useState("");
    const containerRef = useRef();
    let {maxCardsPerRow} = useReportMetricCardDivider(containerRef, 4, lineChartData);

    useEffect(() => {
        props.setPageIdentifier(isUserWise ? t("report.userTitleAria") : t("navigation.institutionReport"));
    }, []);

    useEffect(() => {
        if (!reportStartDate || !reportEndDate) {
            return;
        }

        setDataLoading(true);
        let func = isUserWise ? getUserWiseReport : getInstitutionWiseReport;
        func(reportStartDate, reportEndDate).then(result => {
            const {
                pollCount=0, attendanceCount=0, questionCount=0, responseCount=0, participantCount=0,
                monthsChartCount={},
                lastMonthCount={},
                courseData=[],
                nanCourseCount={},
            } = result;
            setOverviewCount({pollCount, attendanceCount, questionCount, responseCount, participantCount, activityCount: pollCount + attendanceCount});
            setLastMonthCount(lastMonthCount);
            setCoursesData(courseData);
            setNanCourseData(nanCourseCount)
            setLineChartData(convertLineChartData(monthsChartCount));
        }).finally(() => {
            setDataLoading(false);
        });
    }, [isUserWise, reportStartDate, reportEndDate]);

    useEffect(() => {
        if (!!overviewCount.activityCount) {
            const str = overviewCount.activityCount.toString();
            if (str.length > 2) {
                setChartDiagramWidth(45 + (str.length - 2) * 8);
            } else {
                setChartDiagramWidth(45);
            }
        } else {
            setChartDiagramWidth(45);
        }
    }, [overviewCount]);

    useEffect(() => {
        setLastMonthDisplay(getFullMonthYear(reportEndDate));
    }, [reportEndDate, windowWidth]);



    const convertLineChartData = (monthsChartCount={}) => {
        const lineChartData = []
        for (const yearMonth in monthsChartCount) {
            const {totalCount=0, pollCount=0, attendanceCount=0} = monthsChartCount[yearMonth];
            lineChartData.push({name: getShortMonthYear(yearMonth), Overall: totalCount, Polls: pollCount, Attendances: attendanceCount});
        }
        return lineChartData;
    }

    return (
        <div className={classes.parentContainer} ref={containerRef}>
            <div className={classes.titleCard} style={windowWidth < 800 ? {flexDirection: "column"} : {}}>
                <div style={{display: "flex", flexDirection: "column"}}>
                    <span className={classes.title}>{!isUserWise ? t("navigation.institutionReport") : t("report.userTitleAria")}</span>
                    <span style={{height: 15}}/>
                    <span className={classes.description}>{!isUserWise ? t("report.institutionTitleDesc") : t("report.userTitleDesc")}</span>
                </div>
                <div style={windowWidth < 800 ? {height: 20} : {flex: 1}}/>
                <div style={{display: "flex", flexDirection: "column"}}>
                    <div className={classes.filterController}>
                        <span className={classes.regularLabel} style={{marginRight: 5}}>{t("report.dateFilterLabel")}</span>
                        <MonthPicker dateStr={reportStartDate} setDateStr={setReportStartDate}
                                     maxDateStr={reportEndDate}/>
                        <ARROW_RIGHT style={{marginLeft: 5, marginRight: 5}}/>
                        <MonthPicker dateStr={reportEndDate} setDateStr={setReportEndDate}
                                     minDateStr={reportStartDate} maxDateStr={curDate}/>
                    </div>
                </div>
            </div>

            {/*part1: metric card*/}
            {!dataLoading &&
                <div
                    className={classes.metricCardsContainer}
                    style={{gridTemplateColumns: new Array(maxCardsPerRow).fill("1fr").join(" ")}}
                >
                    {/*POLL*/}
                    <div className={`${classes.metricCard}`}>

                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{t("poll.totalGradedPolls")}</div>
                            <div style={{height: 10}}/>
                            <div className={classes.row} style={{gap: 8}}>
                                <div className={classes.metric}>
                                    {!!overviewCount.pollCount ? overviewCount.pollCount.toLocaleString() : 0}
                                </div>
                                <div
                                    className={classes.growBadge}
                                    style={{
                                        background: getMetricBGColorByCount(lastMonthCount.pollCount),
                                        color: getMetricColorByCount(lastMonthCount.pollCount)
                                    }}
                                >
                                    {isCountIncreased(lastMonthCount.pollCount) === false ? "" : "+"}
                                    {!!lastMonthCount.pollCount ? lastMonthCount.pollCount : 0}
                                    {getTrendByCount(lastMonthCount.pollCount)}
                                </div>
                            </div>

                            <div className={classes.month}>
                                {lastMonthDisplay}
                            </div>
                        </div>


                        <POLL_ICON style={{flexShrink: 0}}/>
                    </div>
                    {/*ATTENDANCE*/}
                    <div className={`${classes.metricCard}`}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{t("report.attendanceMetricTitle")}</div>
                            <div style={{height: 10}}/>
                            <div className={classes.row} style={{gap: 8}}>
                                <div className={classes.metric}>
                                    {!!overviewCount.attendanceCount ? overviewCount.attendanceCount.toLocaleString() : 0}
                                </div>
                                <div
                                    className={classes.growBadge}
                                    style={{
                                        background: getMetricBGColorByCount(lastMonthCount.attendanceCount),
                                        color: getMetricColorByCount(lastMonthCount.attendanceCount)
                                    }}
                                >
                                    {isCountIncreased(lastMonthCount.attendanceCount) === false ? "" : "+"}
                                    {!!lastMonthCount.attendanceCount ? lastMonthCount.attendanceCount : 0}
                                    {getTrendByCount(lastMonthCount.attendanceCount)}
                                </div>
                            </div>
                            <div className={classes.month}>
                                {lastMonthDisplay}
                            </div>
                        </div>
                        <ATTENDANCE_ICON style={{flexShrink: 0}}/>
                    </div>


                    {/*RESPONSE*/}
                    <div className={`${classes.metricCard}`}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{t("report.responseMetricTitle")}</div>
                            <div style={{height: 10}}/>
                            <div className={classes.row} style={{gap: 8}}>
                                <div className={classes.metric}>
                                    {!!overviewCount.responseCount ? overviewCount.responseCount.toLocaleString() : 0}
                                </div>
                                <div
                                    className={classes.growBadge}
                                    style={{
                                        background: getMetricBGColorByCount(lastMonthCount.responseCount),
                                        color: getMetricColorByCount(lastMonthCount.responseCount)
                                    }}
                                >
                                    {isCountIncreased(lastMonthCount.responseCount) === false ? "" : "+"}
                                    {!!lastMonthCount.responseCount ? lastMonthCount.responseCount : 0}
                                    {getTrendByCount(lastMonthCount.responseCount)}
                                </div>
                            </div>
                            <div className={classes.month}>
                                {lastMonthDisplay}
                            </div>

                        </div>
                        <RESPONSE_ICON style={{flexShrink: 0}}/>
                    </div>

                    {/*PARTICIPANT*/}
                    <div className={`${classes.metricCard}`}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{t("poll.participantsPlatformText")}</div>
                            <div style={{height: 10}}/>
                            <div className={classes.row} style={{gap: 8}}>
                                <div className={classes.metric}>
                                    {!!overviewCount.participantCount ? overviewCount.participantCount.toLocaleString() : 0}
                                </div>
                                <div
                                    className={classes.growBadge}
                                    style={{
                                        background: getMetricBGColorByCount(lastMonthCount.participantCount),
                                        color: getMetricColorByCount(lastMonthCount.participantCount)
                                    }}
                                >
                                    {isCountIncreased(lastMonthCount.participantCount) === false ? "" : "+"}
                                    {!!lastMonthCount.participantCount ? lastMonthCount.participantCount : 0}
                                    {getTrendByCount(lastMonthCount.participantCount)}
                                </div>
                            </div>
                            <div className={classes.month}>
                                {lastMonthDisplay}
                            </div>
                        </div>
                        <PARTICIPANT_ICON style={{flexShrink: 0}}/>
                    </div>
                </div>
            }


            {!!dataLoading &&
                <div
                    className={classes.metricCardsContainer}
                    style={{gridTemplateColumns: new Array(maxCardsPerRow).fill("1fr").join(" ")}}
                >
                    {/*POLL*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={100}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={30} inline={true} width={60}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>
                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>
                    {/*ATTENDANCE*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 80, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={120}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={30} inline={true} width={60}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>
                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>

                    {/*RESPONSE*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={100}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={30} inline={true} width={60}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>
                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>

                    {/*PARTICIPANT*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={130}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={30} inline={true} width={60}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>
                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>
                </div>
            }

            {/*part2: line chart*/}
            {!dataLoading &&
                <div className={classes.lineChartCardContainer}>
                    <div className={classes.cardContainerHead}>
                        <LINE_CHART_ICON/>
                        {!isUserWise ? t("report.institutionLineChartTitle"): t("report.userLineChartTitle")}
                    </div>
                    <div className={classes.cardContainerBody}>
                        <div className={classes.description}>{!isUserWise ? t("report.institutionLineChartDesc"): t("report.userLineChartDesc")}</div>
                        <div style={{display: "flex", alignItems: "center", flex: 1, columnGap: 40, rowGap: 20, flexWrap: "wrap"}}>
                            <div className={classes.chartControllerContainer}>
                                <div className={classes.lineChartControllerRow}>
                                    <YuJaCheckbox
                                        ariaLabel={"Overall-checkbox"}
                                        checked={showOverallLine}
                                        onChange={() => setShowOverallLine(!showOverallLine)}
                                    />
                                    <div className={classes.overallDiagramDot}/>
                                    <div className={classes.description}>{t("report.institutionLineChartLabelOverall")}</div>
                                    <div style={{flex: 1}}/>
                                    <div className={classes.overallDiagramCountLabel} style={{width: chartDiagramWidth}}>
                                        {overviewCount.activityCount ? overviewCount.activityCount : 0}
                                    </div>
                                </div>

                                <div style={{height: 1, backgroundColor: "#858687"}}/>

                                <div className={classes.lineChartControllerRow}>
                                    <YuJaCheckbox
                                        ariaLabel={"Overall-checkbox"}
                                        checked={showPollLine}
                                        onChange={() => setShowPollLine(!showPollLine)}
                                    />
                                    <div className={classes.pollDiagramDot}/>
                                    <div className={classes.description}>{t("report.institutionLineChartLabelPolls")}</div>
                                    <div style={{flex: 1}}/>
                                    <div className={classes.pollDiagramCountLabel} style={{width: chartDiagramWidth}}>
                                        {!!overviewCount.pollCount ? overviewCount.pollCount : 0}
                                    </div>
                                </div>

                                <div className={classes.lineChartControllerRow}>
                                    <YuJaCheckbox
                                        ariaLabel={"Overall-checkbox"}
                                        checked={showAttendanceLine}
                                        onChange={() => setShowAttendanceLine(!showAttendanceLine)}
                                    />
                                    <div className={classes.attendanceDiagramDot}/>
                                    <div className={classes.description}>{t("report.institutionLineChartLabelAttendances")}</div>
                                    <div style={{flex: 1}}/>
                                    <div className={classes.attendanceDiagramCountLabel} style={{width: chartDiagramWidth}}>
                                        {!!overviewCount.attendanceCount ? overviewCount.attendanceCount : 0}
                                    </div>
                                </div>
                            </div>
                            <div className={classes.chartContainer}>
                                <ResponsiveContainer height={windowWidth > 1200 ? 400 : 300}>
                                    <LineChart data={lineChartData} {...{overflow: 'visible'}}>
                                        <CartesianGrid strokeDasharray="6 6" stroke={"#C4C4C4"}/>
                                        <XAxis dataKey="name" axisLine={false} interval={0}
                                               strokeWidth={2} strokeDasharray={6} stroke={"#737373"}
                                               tick={(props) => LineChartTick({...props, activeLabel, windowWidth})}
                                               tickMargin={10}
                                        >
                                            <Label style={{fontSize: 15}} value="Month" position="bottom"
                                                   offset={35}/>
                                        </XAxis>
                                        <YAxis name="month" style={{fontSize: 15}} axisLine={false} interval={0}
                                               strokeWidth={2} strokeDasharray={6} stroke={"#737373"}
                                               tickMargin={10}
                                        >
                                            <Label angle={270} value="Total Activities" position="left" offset={20}
                                                   style={{fontSize: 15}}/>
                                        </YAxis>

                                        <Tooltip
                                            allowEscapeViewBox={{x: true}}
                                            position={{y: 20}}
                                            content={(props) =>
                                                LineChartTooltip({...props, setActiveLabel, labelArr: lineChartData.map(i => i.name)})
                                            }
                                            cursor={{stroke: "#2C2C2C", strokeWidth: 2, strokeDasharray: 6}}
                                        />


                                        <Line type="monotone" dataKey="Overall" stroke="#4F75CB" strokeWidth={2}
                                              activeDot={{
                                                  stroke: '#4F75CB',
                                                  fill: '#FFFFFF',
                                                  strokeWidth: 3,
                                                  r: 10
                                              }}
                                              hide={!showOverallLine}
                                              dot={false}/>

                                        <Line type="monotone" dataKey="Polls" stroke="#E2726E" strokeWidth={2}
                                              activeDot={{
                                                  stroke: '#E2726E',
                                                  fill: '#FFFFFF',
                                                  strokeWidth: 3,
                                                  r: 10
                                              }}
                                              hide={!showPollLine}
                                              dot={false}/>

                                        <Line type="monotone" dataKey="Attendances" stroke="#6DA186"
                                              strokeWidth={2}
                                              activeDot={{
                                                  stroke: '#6DA186',
                                                  fill: '#FFFFFF',
                                                  strokeWidth: 3,
                                                  r: 10
                                              }}
                                              hide={!showAttendanceLine}
                                              dot={false}/>
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>

                        </div>
                    </div>
                </div>
            }


            {!!dataLoading &&
                <div className={classes.lineChartCardContainer}>
                    <div className={classes.cardContainerHead}>
                        <LINE_CHART_ICON/>
                        {!isUserWise ? t("report.institutionLineChartTitle"): t("report.userLineChartTitle")}
                    </div>
                    <div className={classes.cardContainerBody}>
                        <div style={{display: "flex", alignItems: "center", flex: 1, gap: 40}}>
                            <div className={classes.chartControllerContainer}>
                                <Skeleton borderRadius={10} height={25} inline={true} width={200}
                                          className={classes.cardNumberSkeleton}
                                          containerClassName={classes.cardNumberSkeletonWrapper}
                                />

                                <div style={{height: 1, backgroundColor: "transparent"}}/>
                                <Skeleton borderRadius={10} height={25} inline={true} width={200}
                                          className={classes.cardNumberSkeleton}
                                          containerClassName={classes.cardNumberSkeletonWrapper}
                                />
                                <Skeleton borderRadius={10} height={25} inline={true} width={200}
                                          className={classes.cardNumberSkeleton}
                                          containerClassName={classes.cardNumberSkeletonWrapper}
                                />

                            </div>
                            <div className={classes.chartContainer} style={{gap: 30, flexDirection: "column", justifyContent: "center"}}>
                                <Skeleton borderRadius={10} height={25} inline={true} width={400}
                                          className={classes.cardNumberSkeleton}
                                          containerClassName={classes.cardNumberSkeletonWrapper}
                                />
                                <Skeleton borderRadius={10} height={25} inline={true} width={300}
                                          className={classes.cardNumberSkeleton}
                                          containerClassName={classes.cardNumberSkeletonWrapper}
                                />
                                <Skeleton borderRadius={10} height={25} inline={true} width={200}
                                          className={classes.cardNumberSkeleton}
                                          containerClassName={classes.cardNumberSkeletonWrapper}
                                />
                                <Skeleton borderRadius={10} height={25} inline={true} width={300}
                                          className={classes.cardNumberSkeleton}
                                          containerClassName={classes.cardNumberSkeletonWrapper}
                                />
                                <Skeleton borderRadius={10} height={25} inline={true} width={500}
                                          className={classes.cardNumberSkeleton}
                                          containerClassName={classes.cardNumberSkeletonWrapper}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            }

            {/* part3: table*/}
            {!dataLoading &&
                <div className={classes.tableCardContainer}>
                    <div className={classes.cardContainerHead}>
                        <TABLE_ICON/>
                        {t("report.institutionTableTitle")}
                    </div>
                    <div className={classes.cardContainerBody}>
                        <div className={classes.description}>{t("report.institutionTableDesc")}</div>
                        <Tabs.Root
                            style={{gap: 20}}
                            className={classes.column}
                            value={activeTab}
                            onValueChange={val => setActiveTab(val)}
                        >
                            <Tabs.List className={classes.tabsContainer} activateOnFocus={true}>
                                <Tabs.Tab
                                    className={classes.tab}
                                    value={REPORT_INSTITUTION_PAGE_TAB_KEY.COURSES}
                                >
                                    {REPORT_INSTITUTION_PAGE_TAB_KEY.COURSES}
                                </Tabs.Tab>
                                <Tabs.Tab
                                    className={classes.tab}
                                    value={REPORT_INSTITUTION_PAGE_TAB_KEY.STANDALONE}
                                >
                                    {REPORT_INSTITUTION_PAGE_TAB_KEY.STANDALONE}
                                </Tabs.Tab>
                            </Tabs.List>
                            <Tabs.Panel
                                tabIndex={undefined}
                                className={classes.column}
                                value={REPORT_INSTITUTION_PAGE_TAB_KEY.COURSES}
                                style={{gap: 20}}
                            >
                                <TabCourses data={coursesData} setData={setCoursesData} reportStartDate={reportStartDate}
                                            reportEndDate={reportEndDate}/>
                            </Tabs.Panel>
                            <Tabs.Panel
                                tabIndex={undefined}
                                className={classes.column}
                                value={REPORT_INSTITUTION_PAGE_TAB_KEY.STANDALONE}
                                style={{gap: 20}}
                            >
                                <TabStandalone data={nanCourseData} reportStartDate={reportStartDate}
                                               reportEndDate={reportEndDate} isUserWise={isUserWise}/>
                            </Tabs.Panel>
                        </Tabs.Root>
                    </div>
                </div>
            }

            {!!dataLoading &&
                <div className={classes.tableCardContainer}>
                    <div className={classes.cardContainerHead}>
                        <TABLE_ICON/>
                        {t("report.institutionTableTitle")}
                    </div>
                    <div className={classes.cardContainerBody} style={{gap: 30}}>
                        <Skeleton borderRadius={10} height={25} inline={true} width={350}
                                  className={classes.cardNumberSkeleton}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                        />
                        <Skeleton borderRadius={10} height={30} inline={true} width={300}
                                  className={classes.cardNumberSkeleton}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                        />
                        <Skeleton borderRadius={10} height={30} inline={true} width={"100%"}
                                  className={classes.cardNumberSkeleton}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                        />

                        <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                            <div style = {{display: "grid", gridTemplateColumns: "15% 15% 25%  15% 15%"}}>
                                <Skeleton borderRadius={10} height={30} width={"20%"} style = {{position: "relative"}} />
                                <Skeleton borderRadius={10} height={30} width={"30%"} style = {{position: "relative"}} />
                                <Skeleton borderRadius={10} height={30} width={"80%"} style = {{position: "relative"}} />
                                <Skeleton borderRadius={10} height={30} width={"30%"} style = {{position: "relative"}} />
                                <Skeleton borderRadius={10} height={30} width={"30%"} style = {{position: "relative"}} />
                            </div>
                            <div style = {{ display: "grid", gridTemplateColumns: "15% 15% 25% 15% 15%"}}>
                                <Skeleton borderRadius={10} height={25} width={`${15 + Math.random() * 10}%`} />
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`} />
                                <Skeleton borderRadius={10} height={25} width={`${70 + Math.random() * 10}%`} />
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`} />
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`} />

                                <Skeleton borderRadius={10} height={25} width={`${15 + Math.random() * 10}%`} style = {{marginTop: 15}} />
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`} style = {{marginTop: 15}} />
                                <Skeleton borderRadius={10} height={25} width={`${70 + Math.random() * 10}%`} style = {{marginTop: 15}} />
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`} style = {{marginTop: 15}} />
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`} style = {{marginTop: 15}} />

                                <Skeleton borderRadius={10} height={25} width={`${15 + Math.random() * 10}%`} style = {{marginTop: 15}} />
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`} style = {{marginTop: 15}} />
                                <Skeleton borderRadius={10} height={25} width={`${70 + Math.random() * 10}%`} style = {{marginTop: 15}} />
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`} style = {{marginTop: 15}} />
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`} style = {{marginTop: 15}} />
                            </div>
                        </SkeletonTheme>
                    </div>
                </div>
            }
        </div>
    );
}